
export const OPEN_MODAL = 'modalMessageFields/OPEN_MODAL';
export const CLOSE_MODAL = 'modalMessageFields/CLOSE_MODAL';
export const OPEN_IMPORTANT_FIELDS_MODAL = 'modalMessageFields/OPEN_IMPORTANT_FIELDS_MODAL';
export const CLOSE_IMPORTANT_FIELDS_MODAL = 'modalMessageFields/CLOSE_IMPORTANT_FIELDS_MODAL';
